import { createContext, use, useEffect, type ReactNode } from "react";
import { trustUserInfoQueryOptions, type TrustUserInfo } from "./trustAPI";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useSyncTranslationConfig } from "@privacy/translations";
import { storeTrustLanguage } from "./trustLanguage";

const TrustUserInfoContext = createContext<TrustUserInfo | undefined>(undefined);

export const TrustUserInfoProvider = ({ children }: { children: ReactNode }) => {
  const userInfoQuery = useSuspenseQuery(trustUserInfoQueryOptions());

  useSyncTranslationConfig({ language: userInfoQuery.data.language });

  useEffect(() => {
    storeTrustLanguage(userInfoQuery.data.language);
  }, [userInfoQuery.data.language]);

  return <TrustUserInfoContext value={userInfoQuery.data}>{children}</TrustUserInfoContext>;
};

export const useTrustUserInfo = () => {
  const context = use(TrustUserInfoContext);
  if (!context) throw new Error('"useTrustUserInfo" can only be used within a "TrustUserInfoProvider" ');
  return context;
};
